<script setup>
import { computed } from 'vue';

import WootLabel from 'dashboard/components-next/label/Label.vue';

import { useAutomationOperationsFormatters } from './composables/useAutomationOperationsFormatters';
import { reconciliationRowsOf } from './utils/automationOperationsFormatters';

const props = defineProps({
  result: { type: Object, required: true },
});

const { formatStatus, labelColor } = useAutomationOperationsFormatters();

const reconciliationRows = computed(() => reconciliationRowsOf(props.result));
</script>

<template>
  <div
    class="mt-4 grid gap-3 border border-n-weak bg-n-surface-1 p-3"
    data-test="automation-reconciliation-result"
  >
    <div class="flex flex-wrap items-center justify-between gap-3">
      <span class="text-heading-3 text-n-slate-12">
        {{ $t('AUTOMATION.OPERATIONS.REPLAY.RECONCILE') }}
      </span>
      <WootLabel
        :label="formatStatus(result.receipt_kind)"
        :color="labelColor(result.receipt_kind)"
        compact
      />
    </div>
    <dl class="grid grid-cols-[9rem_minmax(0,1fr)] gap-x-3 gap-y-2">
      <template
        v-for="[label, value] in reconciliationRows"
        :key="`reconcile:${label}`"
      >
        <dt class="text-body-main text-n-slate-11">
          {{ formatStatus(label) }}
        </dt>
        <dd class="min-w-0 break-all text-body-main text-n-slate-12">
          {{ value }}
        </dd>
      </template>
    </dl>
  </div>
</template>
